module.exports = __webpack_public_path__ + "static/img/live-logo.f5cd6769.gif";